import moment from 'moment';
import * as Yup from 'yup';
import { isValid, endOfDay, isBefore, startOfDay, isMatch } from 'date-fns';

import { dateFormat, yupValidateSync } from '@qwealth/qdata';
import { validateDate } from '@qwealth/kyc';

import { DateRange } from '../models/DateRange';
import { BASE_DATE_FORMAT } from 'data/helpers/dateTimeHelper';

export const dateRangeValidator = (field: 'fromDate' | 'toDate', dateRange: DateRange): string | undefined => {
  const value = dateRange[field];
  const { fromDate, toDate } = dateRange;
  return yupValidateSync(
    value,
    validateDate(field, moment(value).format(dateFormat)).test(
      field,
      '"To Date" range must be greater than "From Date" range.',
      () => !fromDate.isValid() || !toDate.isValid() || fromDate.isBefore(toDate.endOf('day')),
    ),
  );
};

export const dateFormatValidator = (date: string | undefined | null): string | undefined => {
  if (!date) return undefined;

  return yupValidateSync(
    date,
    Yup.string()
      .test('Date', '"Date" must be valid "YYYY-MM-DD" format.', () => isMatch(date, BASE_DATE_FORMAT))
      .nullable(),
  );
};

export const startEndDateValidator = (startDateValue: string | undefined, endDateValue: string | undefined): string | undefined => {
  if (startDateValue === undefined || endDateValue === undefined) return undefined;

  return yupValidateSync(
    startDateValue,
    Yup.string()
      .test(
        'Date',
        '"Start Date" value must be before "End Date" value.',
        () => isValid(new Date(startDateValue)) && isBefore(startOfDay(new Date(startDateValue)), endOfDay(new Date(endDateValue))),
      )
      .nullable(),
  );
};
